import React from 'react';

import ScoreItem from './ScoreItem';
import useScore from './useScore';

import './score.scss';

interface Props {
    sportEventId: string;
}

const Score: React.FC<Props> = ({ sportEventId }) => {
    const { scores, currentMatchPart, meta, sportId } = useScore({
        sportEventId,
    });

    return (
        <div styleName="container" className="__app-Score-container">
            {scores.map(score => {
                const key = score.type + score.indexNumber;

                return (
                    <ScoreItem
                        key={key}
                        meta={meta}
                        score={score}
                        currentMatchPart={currentMatchPart}
                        sportId={sportId}
                    />
                );
            })}
        </div>
    );
};

export default Score;
